import React from 'react';

import './style.css';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import SettingsIcon from '@material-ui/icons/Settings';
import Box from '@mui/material/Box';
import { connect } from "react-redux";


class InfoDialog extends React.Component {

    render() {
        return (
        <div>
              <Dialog 
                open={this.props.infoDialog} 
                aria-labelledby="responsive-dialog-title"
              >
                <DialogTitle
                  sx={{
                    backgroundColor: '#0271B8',
                  }}
                >
                  <Box
                    component="img"
                    className="info_dialog_company_logo"
                    alt="NoreFusa Image"
                    src={process.env.PUBLIC_URL+"/images/vlfk_logo.png"}
                  />
                    Fv.564 - Frekhaugkrysset
                </DialogTitle>
                <DialogContent
                  sx={{
                    backgroundColor: '#E5E5E5'
                  }}
                >
                  <DialogContentText>
                    360° bilder over anleggsområdet. Trykk på en av tilgjengelige posisjoner på kartet for å se 360° panorama bilde. 
                    Innstillingene endres med trykk på <SettingsIcon></SettingsIcon>
                  </DialogContentText>
                </DialogContent>
                <DialogActions
                  sx={{
                    backgroundColor: '#E5E5E5'
                  }}
                >
                  <Box
                    component="img"
                    className="info_dialog_logo"
                    alt="Hawkeye Image"
                    src={process.env.PUBLIC_URL+"/hawkeye_logo.png"}
                  />
                  <Button onClick={() => this.props.setInfoDialog(false)}>
                    Close
                  </Button>
                </DialogActions>
                </Dialog>
        </div>
        )
      }
}

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => ({
  setInfoDialog: (infoDialog) => dispatch({type: "update/infoDialog", infoDialog: infoDialog})
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoDialog);